import { BenefitsContentFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import Video from '../../../components/Video';

type BenefitsContentMediaType =
  | 'image'
  | 'video';

type Content = NonNullable<NonNullable<BenefitsContentFragmentFragment['benefitscontent']>['media']>;

const getContentComponent = (content: Content) => {
  switch (content.type?.toLowerCase() as BenefitsContentMediaType | null | undefined) {
    case 'image':
      return content.image
        ? (
          <AppImage
            fallbackHeight={440}
            fallbackWidth={440}
            image={content.image}
          />
        )
        : null;
    case 'video':
      return content.video
        ? <Video src={content.video} />
        : null;
    case undefined:
    case null:
    default:
      return null;
  }
};

interface Props {
  className: string;
  content: Content;
}

const BenefitsContentMedia = ({
  className,
  content,
}: Props) => {
  return (
    <div className={className}>
      {getContentComponent(content)}
    </div>
  );
};

export default BenefitsContentMedia;
